export class SortUtils {
  private constructor() {}

  /**
   * if the item is already in the array, it will be moved to the new position
   *
   * @param array
   * @param item
   * @param refItem - referenceItem which will be before the item
   */
  public static sortIntoArrayAfterItem<T>(
    items: Array<T>,
    item: T,
    refItem: T | null
  ): Array<T> {
    const newItems = [...items];
    const oldItemIndex = newItems.indexOf(item);
    const refItemIndex = refItem ? newItems.indexOf(refItem) : -1;

    if (oldItemIndex > 0 && oldItemIndex === refItemIndex) {
      return newItems;
    }

    let insertionIndex = refItemIndex + 1;
    if (oldItemIndex >= 0) {
      newItems.splice(oldItemIndex, 1); // remove the old item

      if (insertionIndex > oldItemIndex) {
        insertionIndex--;
      }
    }

    newItems.splice(insertionIndex, 0, item);

    return newItems;
  }
}
